import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleNumberedList.module.scss';

const ArticleNumberedList = (props) => {
  const { listItems } = props;

  const formListItem = (listItem, index) => {
    const { simpleNumberedIconListText: text, simpleNumberedIconList: number } =
      listItem;

    return (
      <li key={index}>
        <div className={style.numberCircle}>
          <div className={style.numberText}>{number}</div>
        </div>
        <div>{text}</div>
      </li>
    );
  };

  return (
    <div>
      <ul className={style.numberedList}>
        {listItems?.map((listItem, index) => formListItem(listItem, index))}
      </ul>
    </div>
  );
};

ArticleNumberedList.propTypes = {
  /** An object containing list items. */
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      simpleNumberedIconListText: PropTypes.string.isRequired,
      simpleNumberedIconList: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default ArticleNumberedList;
